import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AdsComponent } from './ads.component';
import { AdsService } from '@fuse/services/ads/ads.service';
import { CommonModule } from '@angular/common';
import { CardModule } from './card/card.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';

const routes = [
    {
        path: 'ads',
        component: AdsComponent
    }
];

@NgModule({
    declarations: [
        AdsComponent
    ],
    imports: [
        RouterModule.forChild(routes),
        CommonModule,
        FuseSharedModule,
        TranslateModule,
        CardModule
    ],
    providers: [
        AdsService
    ],
    exports: [
        AdsComponent
    ],
    entryComponents: [
    ]
})

export class AdsModule {
}
